import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { serviceCategories } from "@/data/services";

const securiteServices = serviceCategories[0]?.services || [];
const travauxServices = serviceCategories[1]?.services || [];

const Services = () => (
  <div className="bg-white" data-testid="services-page">
    <Seo
      title="Services Fast Alu | Sécurité, dépannage, travaux alu/métal"
      description="Découvrez nos services : rideaux métalliques, vitrages, portes blindées, menuiserie aluminium, métallerie et automatismes."
    />
    <section className="bg-brand-blue/5" data-testid="services-hero">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl uppercase" data-testid="services-hero-title">
          Nos services & activités
        </h1>
        <p className="text-brand-ink/70 mt-4" data-testid="services-hero-text">
          Une offre complète orientée dépannage et travaux pour sécuriser vos accès et améliorer vos espaces.
        </p>
      </div>
    </section>

    <div className="max-w-6xl mx-auto px-6 py-16 space-y-12">
      <section data-testid="service-category-securisation">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <h2 className="font-heading text-3xl uppercase" data-testid="service-category-title-securisation">
              Sécurité / Dépannage
            </h2>
            <p className="text-brand-ink/70" data-testid="service-category-desc-securisation">
              Intervention rapide sur rideaux métalliques, vitrages, alarmes et fermetures de sécurité.
            </p>
          </div>
          <Link
            to="/contact"
            className="text-sm uppercase font-semibold text-brand-red"
            data-testid="service-category-cta-securisation"
          >
            Demander un devis
          </Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          {securiteServices.map((service) => (
            <div
              key={service.slug}
              className="border border-brand-blue/15 p-6 rounded-sm bg-white"
              data-testid={`service-item-${service.slug}`}
            >
              <Link to={`/services/${service.slug}`} data-testid={`service-card-link-${service.slug}`}>
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-40 object-cover rounded-sm"
                  data-testid={`service-card-image-${service.slug}`}
                />
              </Link>
              <h3 className="font-heading text-xl uppercase mt-4" data-testid={`service-item-title-${service.slug}`}>
                {service.title}
              </h3>
              <p className="mt-3 text-sm text-brand-ink/70" data-testid={`service-item-benefits-${service.slug}`}>
                {service.benefits.join(" • ")}
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <Link
                  to={`/services/${service.slug}`}
                  className="text-xs uppercase font-semibold text-brand-blue"
                  data-testid={`service-item-more-${service.slug}`}
                >
                  En savoir plus
                </Link>
                <Link
                  to="/contact"
                  className="text-xs uppercase font-semibold text-brand-red"
                  data-testid={`service-item-quote-${service.slug}`}
                >
                  Devis
                </Link>
                <a
                  href="tel:0184160307"
                  className="text-xs uppercase font-semibold text-brand-blue"
                  data-testid={`service-item-call-${service.slug}`}
                >
                  Appelez
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section data-testid="service-category-travaux">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <h2 className="font-heading text-3xl uppercase" data-testid="service-category-title-travaux">
              Travaux / Bâtiment
            </h2>
            <p className="text-brand-ink/70" data-testid="service-category-desc-travaux">
              Menuiserie aluminium, métallerie, automatismes et projets sur-mesure.
            </p>
          </div>
          <Link
            to="/contact"
            className="text-sm uppercase font-semibold text-brand-red"
            data-testid="service-category-cta-travaux"
          >
            Demander un devis
          </Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          {travauxServices.map((service) => (
            <div
              key={service.slug}
              className="border border-brand-blue/15 p-6 rounded-sm bg-white"
              data-testid={`service-item-${service.slug}`}
            >
              <Link to={`/services/${service.slug}`} data-testid={`service-card-link-${service.slug}`}>
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-40 object-cover rounded-sm"
                  data-testid={`service-card-image-${service.slug}`}
                />
              </Link>
              <h3 className="font-heading text-xl uppercase mt-4" data-testid={`service-item-title-${service.slug}`}>
                {service.title}
              </h3>
              <p className="mt-3 text-sm text-brand-ink/70" data-testid={`service-item-benefits-${service.slug}`}>
                {service.benefits.join(" • ")}
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <Link
                  to={`/services/${service.slug}`}
                  className="text-xs uppercase font-semibold text-brand-blue"
                  data-testid={`service-item-more-${service.slug}`}
                >
                  En savoir plus
                </Link>
                <Link
                  to="/contact"
                  className="text-xs uppercase font-semibold text-brand-red"
                  data-testid={`service-item-quote-${service.slug}`}
                >
                  Devis
                </Link>
                <a
                  href="tel:0184160307"
                  className="text-xs uppercase font-semibold text-brand-blue"
                  data-testid={`service-item-call-${service.slug}`}
                >
                  Appelez
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  </div>
);

export default Services;
